import React from "react";

export const CellYTh: React.FC<{ value?: string | number | null }> = ({ value }) => {
  return <th className="cell-y">{value ?? ""}</th>;
};
